// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__VQkHW","aside--noPaddin":"Aside_aside--noPaddin__PAtf8"};